module.exports = __webpack_public_path__ + "1caa43179a2bade087dd894589682df5.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/GC_BIERKIRCHE.jpg
// module id = 616
// module chunks = 0